export default __webpack_public_path__ + "static/media/cc_burgundy.fdd366be.jpg";